<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 数据表格 -->
          <ele-data-table
            ref="projectTable"
            :config="projectTable"
            :current.sync="current"
            @done="done"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="projectName" label="项目" show-overflow-tooltip />
          </ele-data-table>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="addDetail" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">新增细则</el-button>
            <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">批量删除</el-button>
          </div>
          <ele-data-table ref="detailTable" :config="detailTable" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
            <template>
              <el-table-column type="selection" width="45" align="center" />
              <el-table-column prop="projectName" label="考核项目" show-overflow-tooltip align="center">
                <template #default="{ row }">{{ projectList.find((item) => item.id == row.projectId).projectName }}</template>
              </el-table-column>
              <el-table-column prop="itemName" label="项目细则" show-overflow-tooltip align="center" min-width="200" />
              <el-table-column prop="itemType" label="项目属性" show-overflow-tooltip align="center" width="100">
                <template #default="{row}">{{ row.itemType == 1 ? '加分' : row.itemType == 2 ? '减分' : '' }}</template>
              </el-table-column>
              <el-table-column prop="studentScore" label="分值" show-overflow-tooltip align="center" width="100" />
              <el-table-column label="操作" align="center" width="150">
                <template #default="{ row }">
                  <el-link @click="editDetail(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
                  <el-popconfirm title="确定要删除此数据？" @onConfirm="remove(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <!--添加修改考核项目细则-->
    <el-dialog
      :title="editForm.id ? '修改' : '添加'"
      :visible.sync="showEdit"
      width="450px"
      @closed="resetDetailForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="项目名称:" prop="projectId">
          <el-select v-model="editForm.projectId" placeholder="请选择项目" style="width: 100%">
            <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="项目细则:" prop="itemName">
          <el-input v-model="editForm.itemName" placeholder="请输入项目名称" clearable style="width: 100%" />
        </el-form-item>
        <el-form-item label="项目属性:" prop="itemType">
          <el-select v-model="editForm.itemType" placeholder="请选择项目属性" style="width: 100%">
            <el-option label="加分" :value="'1'" />
            <el-option label="减分" :value="'2'" />
          </el-select>
        </el-form-item>
        <el-form-item label="分值:">
          <el-input-number v-model="editForm.studentScore" :min="0" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveDetail">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { delAccessItem, saveAccessItem } from '@/config/yizhongDong/examine';

  export default {
    name: 'schoolOptions',
    data() {
      return {
        projectTable: {
          // 表格配置
          url: '/yzdAccess/schoolAccessProjectList',
          page: false,
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        current: null, // 表格选中数据
        detailTable: {
          // 表格配置
          url: '/yzdAccess/getAccessItemPage',
          method: 'GET',
          where: { projectId: null },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        showEdit: false, // 是否显示表单弹窗
        editForm: {
          // 表单数据
          projectId: null,
          itemName: null,
          itemType: null,
          studentScore: 1,
        },
        editRules: {
          projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
          itemName: [{ required: true, message: '请输入项目细则', trigger: 'blur' }],
          itemType: [{ required: true, message: '请选择项目属性', trigger: 'change' }],
          studentScore: [{ required: true, message: '请输入个人分值', trigger: 'blur' }],
        },
        projectList: [],
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    watch: {
      'current.id': {
        handler(newValue, oldValue) {
          this.detailTable.where.projectId = newValue;
          this.editForm.projectId = newValue;
          this.$refs.detailTable.reload();
        },
      },
    },
    methods: {
      /* 表格渲染完成回调 */
      done(res) {
        this.projectList = res.data;
        if (res.data.length > 0) this.$refs.projectTable.setCurrentRow(res.data[0]);
      },
      addDetail() {
        this.showEdit = true;
      },
      editDetail(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      saveDetail() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveAccessItem(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.detailTable.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除项目细则
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的项目细则吗?', '提示', { type: 'warning' }).then(() => {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            formData.append('ids', ids);
            delAccessItem(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.detailTable.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          });
        } else {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', [row.id]);
          delAccessItem(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.detailTable.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      resetDetailForm() {
        this.editForm = {
          projectId: this.detailTable.where.projectId,
          itemName: null,
          itemType: null,
          studentScore: 1,
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped></style>
